import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router-dom';
import { SWRConfig } from 'swr';
import Loading from 'components/Loading';
import { router } from 'Routes/router';
import { captureApiError } from 'utils/setup/setupSentry';

function App() {
  return (
    <SWRConfig value={{ onError: captureApiError }}>
      <RouterProvider router={router} fallbackElement={<Loading show />} />
    </SWRConfig>
  );
}

export default Sentry.withProfiler(App);
